import { memo } from 'react';
import { Box, Typography, Accordion, AccordionSummary, AccordionDetails } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { usePricing } from '../../../hooks/usePricing';

function Faq({ colors }) {
  const { unitPrice, standardPrice, standardDeclarations } = usePricing();
  return (
        <Box id="home-faq" sx={{ py: { xs: 6, md: 10 } }}>
          <Typography
            variant="h3"
            sx={{
              textAlign: 'center',
              fontWeight: 700,
              mb: 2,
              color: colors.textPrimary,
              fontSize: { xs: '2rem', md: '2.5rem' },
            }}
          >
            Questions fréquentes
          </Typography>
          <Typography
            variant="body1"
            sx={{ textAlign: 'center', color: colors.textSecondary, mb: 6, maxWidth: 600, mx: 'auto' }}
          >
            Tout ce que vous devez savoir avant de déclarer vos œuvres avec Publy.
          </Typography>

          <Box sx={{ maxWidth: 820, mx: 'auto' }}>
            {[
              {
                q: "Ai-je besoin d'un éditeur pour déclarer mes œuvres ?",
                a: "Non. Publy vous permet de déposer vos œuvres à la SACEM en toute indépendance, sans céder vos droits à un éditeur. Vous restez seul maître de votre catalogue.",
              },
              {
                q: 'Faut-il déjà être membre de la SACEM ?',
                a: "Pour percevoir vos droits, vous devez être adhérent de la SACEM. Publy vous aide à préparer les documents nécessaires à la déclaration de vos œuvres ; l'adhésion se fait directement auprès de la SACEM.",
              },
              {
                q: 'Combien de temps prend une déclaration ?',
                a: "Quelques minutes. Notre assistant vous guide question par question, pré-remplit les documents et vérifie leur cohérence. Plus besoin de passer des heures sur des formulaires complexes.",
              },
              {
                q: 'Quels documents Publy génère-t-il ?',
                a: "Le feuillet SACEM, le contrat de cession et d'édition musicale, et le contrat de coédition le cas échéant — le tout généré automatiquement à partir des informations que vous fournissez.",
              },
              {
                q: 'Mes données sont-elles en sécurité ?',
                a: "Oui. Vos données sont chiffrées et stockées de manière sécurisée. Elles ne servent qu'à générer vos documents et ne sont jamais revendues.",
              },
              {
                q: 'Comment fonctionne la signature électronique ?',
                a: "Une fois vos documents générés, vous pouvez les envoyer en signature électronique directement depuis la plateforme et suivre l'état des signatures en temps réel.",
              },
              {
                q: "Quelle est la différence entre l'achat à l'unité et l'abonnement ?",
                a: `Unique (${unitPrice}) couvre une déclaration complète. Standard (${standardPrice}/mois) inclut jusqu'à ${standardDeclarations} déclarations par mois. L'offre Business est sur devis pour les besoins avancés.`,
              },
            ].map((item, index) => (
              <Accordion
                key={index}
                disableGutters
                elevation={0}
                sx={{
                  bgcolor: colors.bgPaper,
                  border: `1px solid ${colors.border}`,
                  borderRadius: 2,
                  mb: 1.5,
                  '&:before': { display: 'none' },
                  '&.Mui-expanded': { borderColor: colors.primaryLight },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon sx={{ color: colors.textSecondary }} />}
                  sx={{ px: { xs: 2, md: 3 }, py: 0.5 }}
                >
                  <Typography sx={{ fontWeight: 600, color: colors.textPrimary }}>
                    {item.q}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ px: { xs: 2, md: 3 }, pb: 2.5, pt: 0 }}>
                  <Typography variant="body2" sx={{ color: colors.textSecondary, lineHeight: 1.7 }}>
                    {item.a}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            ))}
          </Box>
        </Box>
  );
}

export default memo(Faq);
